import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import RockPaperScissors from './pages/RockPaperScissors';
import UnfairDice from './pages/UnfairDice';
import Australia from './pages/Australia';
import Idiot from "./pages/Idiot";
import Scale from "./pages/Scale";
import Home from "./pages/Home";
import Layout from "./pages/Layout";
import Mirror from "./pages/Mirror";
import CookieClicker from './pages/CookieClicker';
import Silence from './pages/Silence';
import Sunlight from './pages/Sunlight';
import Nighttime from './pages/Nighttime';
import Age from './pages/Age';
import PayingUsMoney from './pages/PayingUsMoney';
import NonRandomNumber from './pages/NonRandomNumber';
import Calculator from './pages/Calculator';
import WhiteBoard from './pages/WhiteBoard';
import Height from './pages/Height';

export default function App() {
    return (
        <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="UnfairDice" element={<UnfairDice />} />
            <Route path="RockPaperScissors" element={<RockPaperScissors />} />
            <Route path="Australia" element={<Australia />} />
            <Route path="Scale" element={<Scale />} />
            <Route path="CookieClicker" element={<CookieClicker />} />
            <Route path="mirror" element={<Mirror />} />
            <Route path="idiot" element={<Idiot />} />
            <Route path="Silence" element={<Silence />} />
            <Route path="Sunlight" element={<Sunlight />} />
            <Route path="Nighttime" element={<Nighttime />} />
            <Route path="Age" element={<Age />} />
            <Route path="PayingUsMoney" element={<PayingUsMoney />} />
            <Route path="NonRandomNumber" element={<NonRandomNumber />} />
            <Route path="Calculator" element={<Calculator />} />
            <Route path="WhiteBoard" element={<WhiteBoard />} />
            <Route path="height" element={<Height />} />

            
          </Route>
        </Routes>
        </BrowserRouter>
    );
}  

ReactDOM.render(
    <App />, document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
